import { OVERFLOW_SIDE, PLACEMENT } from './constants';
import getOverflowSides from './getOverflowSides';
import { Placement } from './types';

type CalculateParams = {
  contentMargin: number;
  contentRect: DOMRect;
  pagePadding: number;
  placement: Placement;
  triggerRect: DOMRect;
};

function calculatePlacementStyles({
  contentMargin,
  contentRect,
  pagePadding,
  placement,
  triggerRect,
}: CalculateParams) {
  const {
    bottom: triggerBottom,
    left: triggerLeft,
    right: triggerRight,
    top: triggerTop,
  } = triggerRect;

  const triggerHorizontalCenter = triggerLeft + triggerRect.width / 2;
  const triggerVerticalCenter = triggerTop + triggerRect.height / 2;

  let placementStyles = {
    left: 0,
    top: 0,
  };

  // set initial placement
  switch (placement) {
    case PLACEMENT.TOP:
      placementStyles = {
        left: triggerHorizontalCenter - contentRect.width / 2,
        top: triggerTop - contentRect.height - contentMargin + window.scrollY,
      };
      break;

    case PLACEMENT.BOTTOM:
      placementStyles = {
        left: triggerHorizontalCenter - contentRect.width / 2,
        top: triggerBottom + contentMargin + window.scrollY,
      };
      break;

    case PLACEMENT.LEFT:
      placementStyles = {
        left: triggerLeft - contentRect.width - contentMargin,
        top: triggerVerticalCenter - contentRect.height / 2 + window.scrollY,
      };
      break;

    case PLACEMENT.RIGHT:
      placementStyles = {
        left: triggerRight + contentMargin,
        top: triggerVerticalCenter - contentRect.height / 2 + window.scrollY,
      };
      break;
  }

  // check if content has parts outside the screen after initial placement calculation
  const overflowSides = getOverflowSides(contentRect.width, pagePadding, placementStyles);
  if (!overflowSides) {
    return placementStyles;
  }

  // correct placement if some content parts are outside the screen
  if (overflowSides.includes(OVERFLOW_SIDE.TOP)) {
    placementStyles.top = triggerBottom + contentMargin + window.scrollY; // changes vertical position to "bottom" equivalent
  }
  if (overflowSides.includes(OVERFLOW_SIDE.LEFT)) {
    placementStyles.left = pagePadding;
  }
  if (overflowSides.includes(OVERFLOW_SIDE.RIGHT)) {
    placementStyles.left = window.innerWidth - contentRect.width - pagePadding;
  }

  // extra vertical placement correction for "left"/"right" default placement
  // to avoid overlapping trigger element with content element
  if (
    (PLACEMENT.RIGHT === placement || PLACEMENT.LEFT === placement) &&
    (overflowSides.includes(OVERFLOW_SIDE.LEFT) || overflowSides.includes(OVERFLOW_SIDE.RIGHT))
  ) {
    const isPossibleToPlaceTop = triggerTop - (contentRect.height + contentMargin) > 0;
    placementStyles.top = isPossibleToPlaceTop
      ? triggerTop - contentRect.height - contentMargin + window.scrollY
      : triggerBottom + contentMargin + window.scrollY;
  }

  return placementStyles;
}

export default calculatePlacementStyles;
